/**
 * Common Translations
 * ===================
 * Shared UI strings used across all modules.
 */

import { Translations } from '../types';

export const commonTranslations: Translations = {
    tr: {
        // Buttons
        save: 'Kaydet',
        cancel: 'İptal',
        delete: 'Sil',
        edit: 'Düzenle',
        confirm: 'Onayla',
        close: 'Kapat',
        add: 'Ekle',
        addNew: 'Yeni Ekle',
        back: 'Geri',

        // States
        loading: 'Yükleniyor...',
        saving: 'Kaydediliyor...',
        deleting: 'Siliniyor...',
        exporting: 'Dışa aktarılıyor...',

        // Table
        noDataFound: 'Veri bulunamadı',
        errorLoadingData: 'Veri yüklenirken hata oluştu',
        prev: '← Önceki',
        next: 'Sonraki →',
        pageOf: 'Sayfa {page} / {pages} ({total} kayıt)',
        show: 'Göster',
        filter: 'Filtrele',

        // Toolbar
        filters: 'Filtreler',
        exportAllExcel: 'Tümünü Excel Olarak Dışa Aktar',
        search: 'Ara',
        showHideColumns: 'Sütunları Göster/Gizle',
        resetAll: 'Tümünü Sıfırla',
        done: 'Tamam',

        // Export modal
        format: 'Format',
        exportScope: 'Dışa Aktarma Kapsamı',
        fields: 'Alanlar',
        selectAll: 'Tümünü Seç',
        deselectAll: 'Seçimi Kaldır',
        allRows: 'Tüm satırlar',
        selectedRows: 'Seçili satırlar',
        export: 'Dışa Aktar',
        excelComingSoon: 'Excel (yakında)',

        // Sidebar
        logout: 'Çıkış Yap',
    },
    en: {
        // Buttons
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        confirm: 'Confirm',
        close: 'Close',
        add: 'Add',
        addNew: 'Add New',
        back: 'Back',

        // States
        loading: 'Loading...',
        saving: 'Saving...',
        deleting: 'Deleting...',
        exporting: 'Exporting...',

        // Table
        noDataFound: 'No data found',
        errorLoadingData: 'Error loading data',
        prev: '← Prev',
        next: 'Next →',
        pageOf: 'Page {page} of {pages} ({total} items)',
        show: 'Show',
        filter: 'Filter',

        // Toolbar
        filters: 'Filters',
        exportAllExcel: 'Export All as Excel',
        search: 'Search',
        showHideColumns: 'Show/Hide Columns',
        resetAll: 'Reset All',
        done: 'Done',

        // Export modal
        format: 'Format',
        exportScope: 'Export Scope',
        fields: 'Fields',
        selectAll: 'Select All',
        deselectAll: 'Deselect All',
        allRows: 'All rows',
        selectedRows: 'Selected rows',
        export: 'Export',
        excelComingSoon: 'Excel (coming soon)',

        // Sidebar
        logout: 'Logout',
    },
};
